export { cronToParts } from './cronToParts.js'
export { partsToCron } from './partsToCron.js'

export const REPEAT = {
  HOURLY: 'hourly',
  DAILY: 'daily',
  WEEKDAYS: 'weekdays',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  CUSTOM: 'custom',
  UNKNOWN: 'unknown',
}

export const REPEAT_OPTIONS = [
  { value: REPEAT.HOURLY, label: 'Hourly' },
  { value: REPEAT.DAILY, label: 'Daily' },
  { value: REPEAT.WEEKDAYS, label: 'Weekdays' },
  { value: REPEAT.WEEKLY, label: 'Weekly' },
  { value: REPEAT.MONTHLY, label: 'Monthly' },
  { value: REPEAT.CUSTOM, label: 'Custom' },
]

export const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
export const DAY_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
